var _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChatMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: 120,
    height: 120,
    role: "img",
    "aria-label": "Emcure chat icon with E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 40,
    fill: "#E8252C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 88 L92 108 L70 90 Z",
    fill: "#E8252C"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 60,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontSize: 42,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "bold",
    fill: "#ffffff"
  }, "\r\n    E\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatMessage);
export default __webpack_public_path__ + "static/media/icon-chat-message.746a37a8a089c45dceed12bdf5825188.svg";
export { ForwardRef as ReactComponent };